import { Component } from '@angular/core';

import './not-authorized.scss';

/**
 * /not-authorized
 */
@Component({
  selector: 'not-authorized',
  template: require('./not-authorized.html').default,
})
export class NotAuthorizedComponent {
  constructor() {}
}
